// controls/layout2cols.js — bloc de mise en page 2 colonnes
import React from "react";
import CommonControls from "./inc/Common";

/**
 * Factory : création d’un bloc layout 2 colonnes
 */
export function createLayout3colsField() {
  const id = "layout3cols_" + Date.now();

  return {
    type: "object",
    title: "Bloc 2 colonnes",
    "x-ui": "layout2cols",   // OBLIGATOIRE

    name: id,
    id: id,

    "x-columns": 2,
    "x-structure": [
      [],
      [],
      []
    ],

    properties: {}
  };
}


/**
 * Éditeur BO du layout 2 colonnes
 */
export function EditLayout2colsField({ field, onChange }) {
  return (
    <>
      <CommonControls field={field} onChange={onChange} />

      <div className="alert alert-info small">
        Ce bloc contient 2 colonnes.
        Vous pouvez y glisser-déposer des champs dans l’éditeur.
      </div>
    </>
  );
}

/**
 * FRONT — rendu du bloc layout 2 colonnes
 */
export const RenderLayout2colsField = ({ field, renderChild }) => {
  const columns = field["x-structure"] || [[], []];

  return (
    <div className="row g-3 fb-layout-2cols">
      {columns.map((col, i) => (
        <div key={i} className="col-md-6">
          {col.map((childKey) =>
            renderChild(childKey) // méthode fournie par RenderTabs
          )}
        </div>
      ))}
    </div>
  );
};

/**
 * Compatibilité FieldEditorRegistry
 */
export const editLayout2colsField = (props) => <EditLayout2colsField {...props} />;
